import { atom } from "recoil"
import { ATOMS_KEYS } from "../atom-keys"

export const NewCalenderPageCount = atom<number>({
	key: ATOMS_KEYS.NEWCALENDERPAGE,
	default: 1,
})
